import styled from "styled-components";
import PaxItem from "./PaxItem.styled";
import PaxAction from "./PaxAction.styled";

const SelectPassengerCard = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 24px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};
  border: 1px solid ${({ theme }) => theme.colors.base3};
  max-width: 512px;

  ${PaxItem} {
    border: 1px solid ${({ theme }) => theme.colors.base3};
  }

  ${PaxAction} {
    color: ${({ theme }) => theme.colors.primary2};
  }
`;

export default SelectPassengerCard;
